import { Component, OnInit, OnDestroy, HostBinding } from '@angular/core';
import { NgbModalRef, NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { LoadMapDialogService, LoadMapParams } from './load-map-dialog-service';
import { ISLMap } from 'src/app/types/@types/sl-map';
import { ModalMessagerService } from 'src/app/modal-messager/modal-messager.service';

@Component({
	selector: 'app-load-map-dialog',
	templateUrl: './load-map-dialog.component.html',
	styleUrls: ['./load-map-dialog.component.scss']
})
export class LoadMapDialogComponent implements OnInit {

	public title = 'Load Map';
	private map: ISLMap;
	public options = {
		location: true,
		layerOrder: true,
		layerSettings: true,
		baseMap: true,
		ThreeD: true,
		selectionStyles: true
	};
	@HostBinding('class.work-view') workView = true;

	constructor(private activeModal: NgbActiveModal, private messager: ModalMessagerService) { }

	ngOnInit() {
	}

	Show(params: LoadMapParams) {
		this.map = params.map;
	}
	Load() {
		this.messager.Progress('Retrieving Map Info', false, .5, 'Loading Map');
		this.map.Load(this.options).then(() => {
			this.messager.Progress('Map reload complete', false, 1, 'Loading Map');
			this.activeModal.close();
		}).catch(() => {
			this.messager.Progress('There was a problem reloading the map, some of the requested info may have been restored.', false, 1, 'Loading Map');
			this.activeModal.close();
		});
	}
	Cancel() {
		this.activeModal.close();
	}

}

@Component({
	selector: 'app-load-map-dialog-entry',
	template: ''
})
export class LoadMapDialogEntryComponent implements OnDestroy {
	modalRef: NgbModalRef;
	subscriptionMgr: SubScriptionMgr = new SubScriptionMgr();
	lastTitle: string | null = null;

	constructor(private modalService: NgbModal, private service: LoadMapDialogService) {
		this.subscriptionMgr.Subscribe(this.service.request$, (info: any) => {
			this.modalRef = this.modalService.open(LoadMapDialogComponent, { backdrop: 'static' });
			(this.modalRef.componentInstance as LoadMapDialogComponent).Show(info);
		});
	}
	ngOnDestroy(): void {
		this.subscriptionMgr.CancelSubscriptions();
	}
}
